import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { FourColPortraitStories } from "../../../arrow";
import { getLoadMoreStories } from "../../utils";
import { Button, Headline } from "../../atoms";
import "../../pages/section.m.css";
import { STATIC_KEYWORDS } from "../../../constants";
import { useDeviceType } from "../../customHooks/useDeviceType";
import { getPublishedDate, getPublishedTime } from "../../utils";

const YTShortsPage = (props) => {
  const data = get(props, ["data"], {});
  const { ytShortsData, ytStory } = data;
  const sectionCollection = get(props, ["data", "collection"], {});

  let pageH1 = sectionCollection.name;
  if (ytStory) {
    pageH1 = ytStory.story.headline;
  }

  const parentSecStories = ytShortsData;
  const firstFourStories = parentSecStories?.slice(0, 4) || [];

  const fourToEightParentStories = parentSecStories?.slice(4, 12);

  const [otherParentSecStories, setOtherParentSecStories] = useState(fourToEightParentStories);

  const { LOAD_MORE } = STATIC_KEYWORDS;
  const [enableLoadMore, setEnableLoadMore] = useState(false);
  const [visibleItemsForList, setVisibleItemsForList] = useState(12);
  const [searchCount, setSearchCount] = useState(ytShortsData.length);
  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";

  const getMoreStories = () => {
    let addCount = 8;
    setVisibleItemsForList((prev) => prev + addCount);
    //setOtherParentSecStories((prev) => prev.concat(parentSecStories?.slice(12, 8)));
    setOtherParentSecStories(parentSecStories?.slice(4, visibleItemsForList + addCount));
  };

  useEffect(() => {
    setEnableLoadMore(visibleItemsForList < ytShortsData.length);
  }, [visibleItemsForList]);

  useEffect(() => {
    let contentId = ytStory ? ytStory.story.video_id : "NA";
    let templateName = ytStory ? "detail" : "listing";
    let publishDate = ytStory ? getPublishedDate(ytStory.story?.["first-published-at"]) : "NA";
    let publishTime = ytStory ? getPublishedTime(ytStory.story?.["first-published-at"]) : "NA";
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "dl_page_info",
      cms_author_name: "NA",
      byline: "NA",
      category: "short-videos",
      sub_category: "NA",
      content_id: contentId,
      template_name: templateName,
      publish_date: publishDate,
      publish_time: publishTime,
      login_status: "not-logged-in", // will be changed
      subscription_status: "not-subscribed", // will be changed
      ad_free: false, // will be changed
      login_wall_enabled: false,
      platform: window.innerWidth >= 768 ? "Desktop" : "Mobile",
    });
  }, []);

  return (
    <div styleName="section-page-wrapper visual">
      <div className="container" styleName="section-page">
        <h1 styleName="collection-name">{pageH1}</h1>
        <div styleName="top-template">
          <FourColPortraitStories
            collection={{ ...sectionCollection, items: firstFourStories }}
            isLoadMoreVisible={false}
            showCollectionName={false}
            showReadTime={false}
            pageType="section-page"
            isYTPageImage={true}
            isYTPageHeadline={true}
          />
        </div>
        {otherParentSecStories.length > 0 && (
          <div styleName="template-wrapper">
            <div styleName="last-template">
              <FourColPortraitStories
                collection={{ ...sectionCollection, items: otherParentSecStories }}
                showReadTime={false}
                pageType="section-page"
                isYTPageImage={true}
                isYTPageHeadline={true}
              />
              {enableLoadMore && visibleItemsForList <= searchCount ? (
                <Button onClickFunction={() => getMoreStories()}>{LOAD_MORE}</Button>
              ) : (
                <div style={{ marginBottom: isDesktop ? "" : "16px" }} />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

YTShortsPage.propTypes = {
  data: PropTypes.object,
};

export { YTShortsPage };
